import React, { useEffect, useRef } from "react";
import * as OnfidoSdk from "onfido-sdk-ui";
import { getSteps } from "./StepsConfigurator";
import { logSignup, logReset } from "../../data/onfido";
export const Onfido = ({ token, className, country, locale, steps, allowedDocuments, phrases, confirm, onError, signupId, resetId, track, }) => {
    const onfidoMountId = useRef("onfido_" + Math.random().toString(36).slice(2, 11));
    const comparablePhrases = JSON.stringify(phrases);
    const comparableSteps = JSON.stringify(steps);
    const comparableAllowedDocuments = JSON.stringify(allowedDocuments);
    useEffect(() => {
        const onUserAnalyticsEvent = (event) => {
            if (signupId && track) {
                logSignup(signupId, event.detail);
            }
            if (track) {
                track(event.detail);
            }
            if (resetId) {
                logReset(resetId, event.detail);
            }
        };
        window.addEventListener("userAnalyticsEvent", onUserAnalyticsEvent);
        if (!token) {
            return;
        }
        const onfido = OnfidoSdk.init({
            useModal: false,
            steps: getSteps(comparableSteps ? JSON.parse(comparableSteps) : undefined, comparableAllowedDocuments
                ? JSON.parse(comparableAllowedDocuments)
                : undefined),
            token,
            containerId: onfidoMountId.current,
            language: {
                locale: locale,
                phrases: JSON.parse(comparablePhrases),
            },
            smsNumberCountryCode: country.toString(),
            onComplete: confirm,
            onError: onError,
        });
        return () => {
            window.removeEventListener("userAnalyticsEvent", onUserAnalyticsEvent);
            onfido.tearDown();
        };
    }, [
        confirm,
        country,
        locale,
        onError,
        token,
        comparablePhrases,
        comparableSteps,
        comparableAllowedDocuments,
        signupId,
        resetId,
        track,
    ]);
    return (React.createElement("div", { id: onfidoMountId.current, className: "onfido-mount " + className }));
};
